import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verification-inactive',
  templateUrl: './verification-inactive.component.html',
  styleUrls: ['./verification-inactive.component.css']
})
export class VerificationInactiveComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
